import { Button, HStack, Icon, Text } from '@chakra-ui/react';
import { Master } from 'little-state-machine';
import React from 'react';
import { FiChevronsLeft, FiChevronsRight } from 'react-icons/fi';

import { DateChangerState } from '../hooks/DateChangers';

/**
 * 日付切替状態
 */
export type DateChangerStateBase = {
  /**
   * 年
   */
  year: number;
};

/**
 * 日付切替プロパティ
 */
export type DateChangerProps = {
  isDisabledLeft?: boolean;
  isDisabledRight?: boolean;
  /**
   * 戻るボタンクリックイベント
   */
  onChangeLeft: Consumer<DateChangerState>;
  /**
   * 進むボタンクリックイベント
   */
  onChangeRight: Consumer<DateChangerState>;
  /**
   * 表示
   */
  state: DateChangerState;
  value: string | number;
  applyUnits?: { 1?: Master; 2?: Master; 0?: Master };
};

/**
 * 日付切替
 * @returns
 */
const DateChanger: React.FunctionComponent<DateChangerProps> = (props) => (
  <HStack height={{ base: '20px', md: 'unset' }} justifyContent="space-between">
    <Button
      onClick={() => props.onChangeLeft(props.state)}
      isDisabled={props.isDisabledLeft}
      height={{ base: '20px', md: 'unset' }}
      color="blue.300"
      fontWeight="bold"
    >
      <Icon as={FiChevronsLeft} />
    </Button>
    <Text fontSize={{ base: 'md', md: '2xl' }}>{props.value}</Text>
    {/* { base: 'mobile.3xl', md: '2xl' } */}
    <Button
      onClick={() => props.onChangeRight(props.state)}
      isDisabled={props.isDisabledRight}
      height={{ base: '20px', md: 'unset' }}
      color="blue.300"
      fontWeight="bold"
    >
      <Icon as={FiChevronsRight} />
    </Button>
  </HStack>
);

export default DateChanger;
